<div class="unit-tagging-page">
  <div class="toolbar">
    <button matButton="elevated" (click)="goBack()">
      <mat-icon>arrow_back</mat-icon>
      <span class="buttonLabel">Back</span>
    </button>
    <div class="stats">
      <span class="stat">
        Ship Tag Eligible:
        <strong>{{ shipEligibleCount() }}</strong>
      </span>
      <span class="stat">
        Hi-Rise Eligible:
        <strong>{{ hiRiseEligibleCount() }}</strong>
      </span>
    </div>
    <span class="stat include-shipping-tags">
      <input type="checkbox" [checked]="includeShippingTags()" [disabled]="isReadOnly()" (change)="onIncludeShippingTagsChange($event)" />
      Include Shipping Tags
    </span>
    <span class="spacer"></span>
    @if (includeShippingTags()) {
      <button matButton="elevated" [disabled]="isBusy()" (click)="openSetReference()">
        <span class="buttonLabel">Set Reference</span>
      </button>
      <button matButton="elevated" [disabled]="isBusy()" (click)="openSetLocation()">
        <span class="buttonLabel">Set Location</span>
      </button>
      <button matButton="elevated" [disabled]="isBusy()" (click)="openTagPreview()">
        <mat-icon>visibility</mat-icon>
        <span class="buttonLabel">Tag Preview</span>
      </button>
    }
    <button matButton="elevated" (click)="openHelp()">
      <mat-icon>help_outline</mat-icon>
      <span class="buttonLabel">Help</span>
    </button>
    <button matButton="elevated" [disabled]="isBusy()" (click)="downloadTemplate()">
      <mat-icon>download</mat-icon>
      <span class="buttonLabel">Download</span>
    </button>
    <button matButton="elevated" [disabled]="isBusy() || isTagLocked()" (click)="fileInput.click()">
      <mat-icon>upload</mat-icon>
      <span class="buttonLabel">Upload</span>
    </button>
    <input #fileInput type="file" accept=".xlsx" hidden [multiple]="false" (change)="uploadTemplate(fileInput.files!)" />
    <button matButton="elevated" [disabled]="isBusy() || isTagLocked()" (click)="save(false)">
      <mat-icon>save</mat-icon>
      <span class="buttonLabel">Save Tags</span>
    </button>
  </div>
  @if (errorMessage()) {
    <div class="message error">{{ errorMessage() }}</div>
  }
  @for (message of messages(); track message) {
    <div class="message info">{{ message }}</div>
  }
  @if (showWarningOverride()) {
    <div class="message warn">
      <button matButton="elevated" [disabled]="isTagLocked()" (click)="save(true)">Override and Save Anyway</button>
    </div>
  }
  <div id="unitTaggingTable" class="unit-tagging-table"></div>
  @if (isBusy()) {
    <div class="busy-overlay">
      <mat-progress-spinner mode="indeterminate" diameter="48"></mat-progress-spinner>
    </div>
  }
</div>
